import store from '../../../store/store';
import { CART_ID, getCartIdFromURL } from '../../../common/constants/guest-checkout-api';
import { PARAM_ORDER_ID } from '../../../common/constants/shop-api';
import { StepId } from '../../checkout/shop-checkout.interface';
import { getSuccessUrl } from '../../../common/utils/cart-util';
import { isGuestCheckoutPage } from '../../../common/environment';
import { mhecommSessionStorage } from '../../../common/local-storage';
import { removeCookie } from '../../../common/cookies';
import { updateActiveStep, updateCheckoutInfoSubmitted, updateIsCheckoutComplete } from '../../checkout/shop-checkout';

/**
 * Class to process the result of order placement.
 */
export default class OrderResultProcessor {
  store?: string;

  constructor(store?: string) {
    this.store = store;
  }

  /**
   * Redirects the user to the order confirmation page.
   *
   * @param orderId
   */
  processSuccess(orderId?: string): void {
    const url = new URL(getSuccessUrl(this.store));

    if (orderId) {
      url.searchParams.set(PARAM_ORDER_ID, orderId);
    }

    if (isGuestCheckoutPage()) {
      url.searchParams.set(CART_ID, getCartIdFromURL());
    }
    this.keepOnlyCustomerStateSessionStorage();
    removeCookie('MHCART');

    this.redirect(url.toString());
  }

  /**
   * Redirects the user to the order confirmation page, but the order data is not retrieved.
   */
  processPartial(): void {
    const url = new URL(getSuccessUrl(this.store));
    this.keepOnlyCustomerStateSessionStorage();
    removeCookie('MHCART');

    this.redirect(url.toString());
  }

  /**
   * Redirects the user to the payment step.
   *
   * State changes are dispatched to the checkout step and order placement components.
   */
  processFailure(): void {
    store.dispatch(updateIsCheckoutComplete(false));
    store.dispatch(updateCheckoutInfoSubmitted(false));
    store.dispatch(updateActiveStep(StepId.PaymentBillingAddressStep));
  }

  /**
   * State changes are dispatched to the checkout step and order placement components.
   */
  processOrderStatus(): void {
    store.dispatch(updateIsCheckoutComplete(true));
    store.dispatch(updateCheckoutInfoSubmitted(false));
  }

  /**
   * Cleans the session storage.
   *
   * @private
   */
  private keepOnlyCustomerStateSessionStorage(): void {
    const customerState = store.getState().customerState;
    const userProfileState = store.getState().userProfileState;
    sessionStorage.clear();
    mhecommSessionStorage.saveState({customerState: customerState, userProfileState: userProfileState});
  }

  /**
   * Redirects to the given URL.
   *
   * @param url
   */
  private redirect(url: string): void {
    window.location.href = url;
  }
}
